import { render, staticRenderFns } from "./ReferWindow.vue?vue&type=template&id=f40e0fdc&"
import script from "./ReferWindow.vue?vue&type=script&lang=js&"
export * from "./ReferWindow.vue?vue&type=script&lang=js&"
import style0 from "./ReferWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReferWindow.vue"
export default component.exports